export const featured = [
  {
    dramaId: "drama-001",
    tagline: "烟雨长安，一卷密档牵动朝堂风云",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20an%20ancient%20Chinese%20city%20under%20misty%20rain%20at%20night%2C%20warm%20lantern%20glow%2C%20deep%20blue%20sky%2C%20atmospheric%20historical%20drama%20backdrop&width=1600&height=900&seq=hero-changan-night-01&orientation=landscape",
  },
  {
    dramaId: "drama-005",
    tagline: "深巷尽头的一束光，照见最深的黑暗",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20dark%20rainy%20city%20alley%20at%20night%20with%20a%20single%20warm%20street%20light%2C%20moody%20suspense%20backdrop&width=1600&height=900&seq=hero-alley-night-01&orientation=landscape",
  },
  {
    dramaId: "drama-007",
    tagline: "大漠孤烟直上，一人一剑守一座关",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20vast%20desert%20dunes%20at%20golden%20sunset%20with%20drifting%20smoke%2C%20epic%20wuxia%20backdrop&width=1600&height=900&seq=hero-desert-sunset-01&orientation=landscape",
  },
  {
    dramaId: "drama-012",
    tagline: "午夜列车驶出隧道，有人凭空消失",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20night%20train%20speeding%20through%20dark%20landscape%20with%20glowing%20windows%2C%20crime%20thriller%20backdrop&width=1600&height=900&seq=hero-midnight-train-01&orientation=landscape",
  },
];